const getters = {
    id: state => state.id,
    profil: state => ({ ...state.profil }),
    permissions: state => state.permissions,
    me: state => ({
        uid: state.id,
        profil: { ...state.profil},
    }),
    isAuthenticated: state => state.isAuthenticated,
    isAuthorised: state => (permList) => {
        const permissions = Object.keys(state.permissions);
        return permList.filter((n) => {
            return permissions.indexOf(n) !== -1;
        }).length > 0;
    },
    fullname: state => {
        if (state.profil.givenName && state.profil.sn) {
            return `${state.profil.givenName} ${state.profil.sn}`;
        }
        return '';
    },
    givenname: state => {
        if (state.profil.givenName) {
            return `${state.profil.givenName}`;
        }
        return '';
    },
    sn: state => {
        if (state.profil.sn) {
            return `${state.profil.sn}`;
        }
        return '';
    },
    titre: state => state.profil.personalTitle || '',
};

export default getters;